// Carto.vue

<template>

   <v-container>
      <AdrTech  @addAdrTech = "addAdrTech"  @closeDialogAdrTech = "closeDialogAdrTech" v-if="dialogAdrTech" v-bind:ftthService="ftthService" />

      <v-row>
         <v-col cols='8' v-if="dynamiqueMap"><h1>Test d'éligibilité aux offres BOX</h1></v-col>
         <v-col cols='8' v-if="!dynamiqueMap"><h1>Vérifier les coordonnées</h1></v-col>
         <v-col cols='4' class="text-right"><v-btn to="/souscription/offresbox/eligibilite/adresse">Retour</v-btn></v-col>
      </v-row>
      <v-divider></v-divider>
      <br/>

      <p class="para" v-if="dynamiqueMap">Positionnez le marqueur <v-icon color='tertiary'>mdi-map-marker</v-icon> au dessus du logement puis cliquez sur le bouton "<strong>Tester l'éligibilité</strong>" :</p>

      <p class="para" v-if="!dynamiqueMap">Verifier l'adresse ci-dessous liée à votre référence d'immeuble puis cliquez sur le bouton "<strong>Poursuivre</strong>" :
      <br/>
      <strong>{{eligibilite.adresse.label}}</strong></p>
      <br/>

       <v-overlay :value="loading"></v-overlay>

       <v-row>
          <v-col cols="12" sm="12" md="10" lg="10" offset-lg="1" offset-md="1">
  <!--<div style="height:800px;;margin-right:15px;margin-left:15px;"  >-->
    <div  v-bind:style="{ height: heightMap + 'px' }" style="margin-right:15px;margin-left:15px" >
    <!-- Latitude : <input type="text" v-model="latitude"> / Longitude : <input type="text" v-model="longitude">
currentZoom <input type="text" v-model="currentZoom"> -->
    <l-map
      :zoom="zoom"
      :center="center"
      :options="mapOptions"
      style="height: 100%;z-index:1"
      @update:zoom="zoomUpdate"
      @click="onMapClick"
    >
    <l-control-layers position="topright"></l-control-layers>

    <l-tile-layer
      v-for="tileProvider in tileProviders"
      :key="tileProvider.name"
      :name="tileProvider.name"
      :visible="tileProvider.visible"
      :url="tileProvider.url"
      :attribution="tileProvider.attribution"
      :options="{ maxNativeZoom: maxNativeZoom, maxZoom: maxZoom }"

      layer-type="base"/>

      <l-tile-layer 
        :url="tilePoint.url"
        :attribution="tilePoint.attribution"
        :options="{ maxNativeZoom: maxNativeZoom, maxZoom: maxZoom }"
        :zIndex="10"
      />
      <l-marker :lat-lng="withPopup" :draggable="dynamiqueMap" v-on:move="bouge($event)" ref="myMarker">
        <l-popup>
          <div @click="innerClick">
            Aide
            <p v-show="showParagraph">
              Déplacez le marqueur au dessus du logement à tester<br/>Utilisez le zoom pour un placement plus précis
            </p>
            
          </div>
        </l-popup>
      </l-marker>

      <l-control position="bottomright">
        <v-btn class="btn_legende" small @click="toggleLegend()">Legende</v-btn>
      </l-control>
      <l-control position="bottomleft">
        <!-- <img class="img_legende" src="https://geo.intranet.local/geoserver/sig/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&LAYER=rapport_beb_mk2&legend_options=fontAntiAliasing:true" alt="legend" width="204" height="140" :hidden="!showLegend"> -->
        <img class="img_legende" :src="urlLegende" alt="legend" width="204" height="140" :hidden="!showLegend">
      </l-control>

    </l-map>
      
   </div>
   </v-col>
   </v-row>
   <br/>
   <v-row align="center">
      <v-col cols="12" sm="10" md="6" lg="6" offset-sm="1" offset-md="3" offset-lg="3">
         <v-btn v-if="dynamiqueMap" @click="getEligibilite" :loading="loading" class="tester" block>Tester l'éligibilité</v-btn>
         <v-btn v-if="!dynamiqueMap" @click="getEligibilite" :loading="loading" class="tester" block>Poursuivre</v-btn>
      </v-col>
   </v-row>
  <br/>

  <div v-if="eligibilite">
  <v-dialog persistent v-model="dialogService" max-width="540" min-height="500">
    <v-card>
      <v-card-title class="justify-center secondary diag_titre">Test d'éligibilité</v-card-title>
      <v-card-text class="pa-6">
        <p class="intro">Le logement sélectionné est éligible aux catégories d'offres suivantes :</p>
        <v-list class="mt-8" align='center'>
          <v-list-item class="pa-0" v-for="(service, index) in eligibilite.service" :key="service.type" v-show="index==0 || (index > 0 && otherserviceisShow)">
            <v-card width="100%" class="pa-2 ml-9 mr-9" :class="{ premService: index == serviceSelected, defService: index != serviceSelected }" @click="selectService(index)">
              {{ formatService(service.type) }}
              <div v-if="$globalService.checkDateCommercialisation(service)" class="dateComm">Date de commercialisation : {{$globalService.formatDateMysqlToPhp($globalService.getDateCommercialisation(service.date_commercialisation))}}</div>
              <div v-if="service.commercialisable === false && service.erreur" class="dateComm">
                {{ service.erreur.message }}<br/>
                Motif: {{ service.erreur.motif }}<br/>
                Date de dégel: {{ $globalService.formatDateMysqlToPhp(service.erreur.date_degel) }}
              </div>
            </v-card>
          </v-list-item>
        </v-list>
        <v-btn x-small text v-if="eligibilite.service.length > 1" v-on:click="otherservice()" class="mt-3 ml-9">
          <v-icon left v-if="!otherserviceisShow">mdi-plus</v-icon>
          <v-icon left v-if="otherserviceisShow">mdi-minus</v-icon>
        Autres catégories éligibles</v-btn>
      </v-card-text>

      <v-card-actions class="pa-5">
        <v-spacer></v-spacer>
        <v-btn @click="dialogService=false">Annuler</v-btn>
        <v-btn @click="valideService()" :loading="loading2" :disabled="!eligibilite.service[serviceSelected] || eligibilite.service[serviceSelected].commercialisable === false">Suivant</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </div>

  <div v-if="eligibilite && cableRues">
    <v-dialog persistent scrollable v-model="dialogCableRues" max-width="560" min-height="500">
      <v-card>
        <v-card-title class="justify-center secondary diag_titre">Identification du logement</v-card-title>
        <v-card-text class="pa-6">
          <p class="intro">Veuillez utiliser les menus ci-dessous pour identifer le logement dans la base d'adresses câble :</p>
          <v-expansion-panels focusable accordion v-model="cableAide">
            <v-expansion-panel>
              <v-expansion-panel-header disable-icon-rotate>
                Aide : afficher l'adresse postale du point géographique
                <template v-slot:actions>
                  <v-icon color="primary">
                    mdi-map-marker-radius
                  </v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                {{ eligibilite.adresse.label }}
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-autocomplete
            class = "mt-12"
            outlined
            label="Nom de rue"
            v-model="cableRue"
            :items="cableRues"
            item-text="voie"
            clearable
            return-object
            v-on:change="selectCableRue()"
          ></v-autocomplete>

          <v-autocomplete
            outlined
            label="Numéro de rue / Bâtiment"
            v-model="cableRueNumero"
            :disabled="!cableRue"
            :items="cableRueNumeros"
            :item-text="item => item.numero_voie + ' ' + item.complement_numero_voie + ' ' + item.batiment"
            clearable
            return-object
            v-on:change="selectCableNumeroRue()"
          ></v-autocomplete>

          <v-autocomplete
            outlined
            label="Référence de prise"
            v-model="cableLogement"
            :disabled="!cableRueNumero || !cableRue || !cableLogements" 
            :items="cableLogements"
            :item-text="item => 'Référence de prise: ' + item.ref_prise"
            clearable
            return-object
          >
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-subtitle>Numéro de voie: <strong>{{ item.numero_voie }} {{ item.complement_numero_voie }}</strong></v-list-item-subtitle>
                <v-list-item-subtitle>Bâtiment: <strong>{{ item.batiment }}</strong></v-list-item-subtitle>
                <v-list-item-subtitle>Escalier: <strong>{{ item.escalier }}</strong></v-list-item-subtitle>
                <v-list-item-subtitle>Etage: <strong>{{ item.etage }}</strong></v-list-item-subtitle>
                <v-list-item-subtitle>Référence prise: <strong>{{ item.ref_prise }}</strong></v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>

        </v-card-text>
        <v-card-actions class="pa-5">
          <v-spacer></v-spacer>
          <v-btn @click="dialogCableRues=false">Annuler</v-btn>
          <v-btn @click="valideCableRefPrise()" :loading="loading2">Suivant</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>


  </v-container>
</template>

<script>
import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet';
import {EligibiliteService} from '../../../../../providers/EligibiliteService.js';
const eligibiliteService = new EligibiliteService();
import { AppService } from '../../../../../providers/AppService';
const appService = new AppService();

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});
   
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LControlLayers, LControl/* , LTooltip */ } from "vue2-leaflet";
import AdrTech from '../adrtech/AdrTech.vue'
export default {
  name: "Carto",
  components: {
    AdrTech,
    LMap,
    LTileLayer,
    LControlLayers,
    LMarker,
    LPopup,
    LControl/* ,
    LTooltip */
  },
  mounted: function () {
      this.init();
  },
  data() {
    return {
      showLegend: false,
      dialogService: false,
      otherserviceisShow : false,
      serviceSelected: 0,
      cableRues: null,
      cableRue: null,
      cableRueNumeros: null,
      cableRueNumero: null,
      cableLogement: null,
      cableLogements: null,
      cableAide: null,
      dialogCableRues: false,
      dialogAdrTech : false, 
      loading:false,
      loading2:false,
      eligibilite: null,
      ftthService:null,
      zoom: 17,
      currentZoom: 17,
      maxNativeZoom: 19,
      maxZoom: 21,
      mapOptions: {
        zoomSnap: 0.5
      },
      latitude:0,
      longitude:0,
      center: latLng(0, 0),
      currentCenter: latLng(0, 0),
      withPopup: latLng(0, 0),
      showParagraph: true,
      dynamiqueMap:true,
      heightMap :800,
      tileProviders: [
        {
          name: 'Geoplateforme',
          visible: true,
          url: "https://data.geopf.fr/wmts?" +
                  "&REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0" +
                  "&STYLE=normal" +
                  "&TILEMATRIXSET=PM" +
                  "&FORMAT=image/jpeg" +
                  "&LAYER=ORTHOIMAGERY.ORTHOPHOTOS" +
                  "&TILEMATRIX={z}" +
                  "&TILEROW={y}" +
                  "&TILECOL={x}",
          attribution: "IGN-F/Geoplateforme",
        },
        {
          name: 'OpenStreetMap',
          visible: false,
          url: "http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
          attribution: "Map data &copy; <a href=\"http://openstreetmap.org/copyright\">OpenStreetMap</a>",
        }
        ,
        {
          name: 'Goggle sat',
          visible: false,
          maxZoom: 21,
          maxNativeZoom: 19,
          url: "http://mt0.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}",
          attribution: 'Map data &copy; <a href="https://www.google.com/maps">Google Maps</a>',
        }
        /*,
        {
          name: 'Goggle sat hybride',
          visible: false,
          maxZoom: 21,
          maxNativeZoom: 19,
          url: "http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}",
          attribution: 'Map data &copy; <a href="https://www.google.com/maps">Google Maps</a>',
        }*/
      ],
      tilePoint: {
        url: appService.getApiUrl()+"eligibilite/getLayerFtth.php?" +
                  "layer=sig:rapport_beb_mk2" +
                  "&style=" +
                  "&tileMatrixSet=EPSG:3857" +
                  "&service=WMTS" +
                  "&request=GetTile" +
                  "&version=1.0.0" +                  
                  "&format=image%2Fpng8" +
                  "&tileMatrix=" + ((this.$root && this.$root.user && (this.$root.user.site == 'MTQ' || this.$root.user.site == 'GUY' || this.$root.user.site == 'GPE')) ? "{z}" : "EPSG%3A3857%3A{z}") +
                  "&tileCol={x}" +
                  "&tileRow={y}"+
                  "&app_version="+appService.APP_VERSION,
        attribution: "Rapport_beb_mk2"
      },
      urlLegende: appService.getApiUrl()+"eligibilite/getLegend.php?" +
                      "REQUEST=GetLegendGraphic" +
                      "&VERSION=1.0.0" +
                      "&FORMAT=image/png" +
                      "&WIDTH=20" +
                      "&HEIGHT=20" +
                      "&LAYER=rapport_beb_mk2" +
                      "&legend_options=fontAntiAliasing:true" +
                      "&app_version="+appService.APP_VERSION,

    };
  },
  methods: {
    toggleLegend: function() {
      if(this.showLegend === true) {
        this.showLegend = false;
      } else {
        this.showLegend = true;
      }
    },
    closeDialogAdrTech: function(){
      this.dialogAdrTech = false;
    },
    addAdrTech:function(adrTech, onDone){
       //this.dialogAdrTech = false;
      this.$globalService.setSessionSouscription('adrTech',adrTech);

      //if(this.$root.user.type =='PRO'){
        this.setInfoFtth(this.eligibilite.id_eligibilite,adrTech, onDone);

      /*}else{
        this.$router.push({name: 'ChoixOffreOption'});
      }*/
    },
    existFtth: function(){
      var exist = false;
      
      for (var item in this.eligibilite.service) {
        if(this.eligibilite.service[item].type== 'ftth'){
          this.ftthService = this.eligibilite.service[item];
          exist = true;
        }
      }
      return exist;
    },

    setInfoFtth: function(id_eligibilite,adrTech, onDone){
      eligibiliteService.setFibreLogement(id_eligibilite,adrTech).then((res) => {
        
           if (onDone) onDone();
          if (res) {
            if (res.err != "error") {
              this.dialogAdrTech = false;
              if(this.$root.user.type=='PRO') {
                this.$router.push({name: 'ResultElig'});
              } else {
                this.$router.push({name: 'ChoixOffreOption'});
              }
                    
            }else{

              this.$dialog.error({
                text: res.err_msg,
                title: 'Erreur',
                persistent: false,
                actions: {
                  false: 'Fermer'
                }
              })
            
            }
          }
        })
        .catch((error) => {
          if (onDone) onDone();
          this.$dialog.notify.error(this.$root.errorMessage, {
            position: "bottom-right",
            timeout: 5000,
          });
          return error;
        });
    },
    getEligibilite: function(){
        this.cableAide = null;
        if(this.eligibilite){

          if(this.$root.user.type=='PRO') {
            if(this.existFtth()) {
              if(this.ftthService.logements.length == 1){
                this.addAdrTech(this.ftthService.logements[0]);
              }else{
              //affichage de la liste des logements
                this.dialogAdrTech = true;
              }
            } else {
              this.$dialog.warning({
                text: "Ce logement n'est pas éligible aux offres FIBRE",
                title: "Test d'éligibilité",
                persistent: true
              });
            }
          } else {
            // affichage liste services éligibles
            this.dialogService = true;
          }

             
         }else{
           this.loading = true;
          eligibiliteService.getEligibiliteByCoord(this.latitude,this.longitude,this.$root.user.domaine,this.$root.user.site).then(res => { 
            this.loading = false;
            if(res){
              if ( res.err !='error' && res.params.eligibilite) {
                this.eligibilite = res.params.eligibilite;
                this.eligibilite.lat = this.latitude;
                this.eligibilite.lon = this.longitude;
                this.$globalService.setUser(res.params.user);
                const sessionSouscription = this.$globalService.setSessionSouscription('eligibilite',res.params.eligibilite);
                if(sessionSouscription == null || !sessionSouscription.eligibilite){
                  this.$dialog.error({
                    text: "Une erreur s'est produite",
                    title: 'Erreur',
                    persistent: false,
                    actions: {
                      false: 'Fermer'
                    }
                  })
                }

                if(this.$root.user.type=='PRO') {
                  if(this.existFtth()) {
                    if(this.ftthService.logements.length == 1){
                      this.addAdrTech(this.ftthService.logements[0]);
                    }else{
                    //affichage de la liste des logements
                      this.dialogAdrTech = true;
                    }
                  } else {
                    this.$dialog.warning({
                      text: "Ce logement n'est pas éligible aux offres FIBRE",
                      title: "Test d'éligibilité",
                      persistent: true
                    });
                  }
                } else {
                  this.dialogService = true;
                }
              
                 
                 
              }else{
                this.$dialog.error({
                  text: 'Erreur lors de la vérification de votre éligibilité',
                  title: "Erreur d'eligibilite",
                  persistent: false,
                  actions: {
                    false: 'Fermer'
                  }
                })
              }
            }
        }).catch(error=>{
    
              this.loading = false;
              this.$dialog.notify.error(this.$root.errorMessage, {
                        position: 'bottom-right',
                        timeout: 5000
                      })
            return error;
          })
      }
  },
     bouge: function (event) {
               this.latitude = event.latlng.lat;
               this.longitude = event.latlng.lng;
               if(this.eligibilite){
                 this.eligibilite = null;
                 sessionStorage.removeItem('souscription');
               }

            },

   zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
      this.$refs.myMarker.setLatLng([this.currentCenter.lat, this.currentCenter.lng]);
    },
    showLongText() {
      this.showParagraph = !this.showParagraph;
    },
    innerClick() {
      alert("Click!");
    },
    onMapClick(event) {
      if(this.dynamiqueMap)
        this.$refs.myMarker.setLatLng([event.latlng.lat, event.latlng.lng]);
    },

    init(){

       //récuperation dans la session
      var sessionSouscription = this.$globalService.getSessionSouscription();
      if(sessionSouscription != null && sessionSouscription.eligibilite){
        this.eligibilite = sessionSouscription.eligibilite;
        this.latitude = this.eligibilite.lat ;
        this.longitude = this.eligibilite.lon;
        if(this.eligibilite.gotBy && this.eligibilite.gotBy == 'refImmeuble'){
          this.dynamiqueMap = false;
          this.heightMap = 600;
        }else{
          this.dynamiqueMap = true;
          this.heightMap = 800;
        }
        this.existFtth();
      }else{
        this.latitude = this.$route.query.lat;
        this.longitude = this.$route.query.lon;
      }
       
        this.center = latLng(this.latitude,this.longitude);
        this.withPopup = latLng(this.latitude,this.longitude);
        this.currentCenter = latLng(this.latitude,this.longitude);
    },
    selectService(index) {
      this.serviceSelected = index;
    },
    otherservice() {
      this.otherserviceisShow = !this.otherserviceisShow;
      if(!this.otherserviceisShow) {
        this.serviceSelected = 0;
      }
    },
    valideService() {
      //enregistrement en session du service choisi
      const sessionSouscriptionServiceChoisi = this.$globalService.setSessionSouscription('serviceChoisi',this.eligibilite.service[this.serviceSelected]);
      if(sessionSouscriptionServiceChoisi == null || !sessionSouscriptionServiceChoisi.serviceChoisi){
        this.$dialog.error({
          text: "Probleme d'enregistrement du service choisi",
          title: 'Erreur',
          persistent: false,
          actions: {
            false: 'Fermer'
          }
        })
        return;
      } else {
        if(this.eligibilite.service[this.serviceSelected].type== 'ftth') {
          this.existFtth();
          if(this.ftthService.logements.length == 1){ 
            // pas la peine d'afficher la liste des logements
            this.loading2 = true;
            this.addAdrTech(this.ftthService.logements[0], () => {
              this.loading2 = false;
            });
          }else{
            //affichage de la liste des logements
            this.dialogAdrTech = true;
          }

        } else if(this.eligibilite.service[this.serviceSelected].type== 'cable') {

          this.loading2 = true;
          eligibiliteService.getCableRues(this.eligibilite.id_eligibilite).then(res => { 
            this.loading2 = false;
            if(res){
              if ( res.err !='error' && res.params.cableRue) {
                this.cableRues = res.params.cableRue;
                this.dialogService = false;
                this.dialogCableRues = true;

              }
            }

          }).catch(error=>{
            this.loading2 = false;
            this.$dialog.notify.error(this.$root.errorMessage, {
              position: 'bottom-right',
              timeout: 5000
            })
            return error;
          });

        } else {  // autres catégories d'offres
          // si VAD 
          //affichage de la liste des offres
          if(this.$root.user.type!='PRO')
            this.$router.push({name: 'ChoixOffreOption'});
          else{
          // si PRO 
          //affichage de la liste des offres
            this.$router.push({name: 'ResultElig'});
          }
        }
      }

    },
    formatService(service) {
      var fserv;
      if(service == 'ftth') {
        fserv = 'FIBRE';
      } else if(service == 'wttx') {
        fserv = "BOX 4G";
      } else {
        fserv = service;
      }
      fserv = fserv.toUpperCase();
      return fserv;
    },
    selectCableRue: function() {
      this.cableRueNumero = null;
      this.cableLogement = null;
      if(this.cableRue) {
        eligibiliteService
          .getCableRueNumeros(this.eligibilite.id_eligibilite, this.cableRue.code_rivoli)
          .then((res) => {
            if (res) {
              if (res.err != "error" && res.params) {
                this.cableRueNumeros = res.params.cableRueNumero;
              } 
            }
          })
          .catch((error) => {
            this.$dialog.notify.error(this.$root.errorMessage, {
              position: "bottom-right",
              timeout: 5000,
            });
            return error;
          });
      }
    },
    selectCableNumeroRue: function() {
      this.cableLogement = null;
      if(this.cableRue && this.cableRueNumero) {
        eligibiliteService
          .getCableLogements(this.eligibilite.id_eligibilite, this.cableRueNumero.batiment, this.cableRueNumero.complement_numero_voie, this.cableRueNumero.numero_voie, this.cableRue.code_rivoli)
          .then((res) => {
            if (res) {
              if (res.err != "error" && res.params) {
                this.cableLogements = res.params.cableLogement;
              } else {
                this.cableLogements = null;
              }
            }
          })
          .catch((error) => {
            this.$dialog.notify.error(this.$root.errorMessage, {
              position: "bottom-right",
              timeout: 5000,
            });
            return error;
          });
      }
    },
    valideCableRefPrise: function() {
      if(!this.cableLogement) {
          this.$dialog.warning({
            text: "Veuillez rechercher la référence de prise du logement",
            title: "Identification du logement",
            persistent: true
          });
      } else {
        // enregistrement en session de l'adresse technique
        this.$globalService.setSessionSouscription('adrTech',this.cableLogement);

        // setCableLogement
        this.loading = true;
        eligibiliteService.setCableLogement(this.eligibilite.id_eligibilite, this.cableLogement.code_rivoli, this.cableLogement.batiment, this.cableLogement.complement_numero_voie, this.cableLogement.escalier, this.cableLogement.etage, this.cableLogement.numero_voie).then((res) => {
            this.loading = false;
            if (res) {
              if (res.err != "error") {
                this.$router.push({name: 'ChoixOffreOption'});
              }else{
                this.$dialog.error({
                  text: res.err_msg,
                  title: 'Erreur',
                  persistent: false,
                  actions: {
                    false: 'Fermer'
                  }
                })
              
              }
            }
          })
          .catch((error) => {
            this.loading = false;
            this.$dialog.notify.error(this.$root.errorMessage, {
              position: "bottom-right",
              timeout: 5000,
            });
            return error;
          });

       

      }

    }
  }
};
</script>

<style>
  p.intro {
    font-size:1.16rem !important;
  }
   .tester {
      background-image: linear-gradient(to right,var(--v-violet-base) 0,var(--v-rubine-base) 100%);
      color:white !important;
   }
   .btn_legende {
     font-size:9px !important;
     height:20px !important;
     padding:0 8px !important;
     box-shadow: 0 1px 5px rgba(0,0,0,0.4);
   }
   .img_legende {
     border-radius: 5px;
     box-shadow: 0 1px 5px rgba(0,0,0,0.4);
   }
   .premService {
      background-image: linear-gradient(to right,var(--v-violet-base) 0,var(--v-rubine-base) 100%);
      color:white !important;
      font-weight:bold;
      font-size:1.3rem;
    }
    .defService {
      background-color: lightgray !important;
      font-size:1.0rem;
    }
    .diag_titre {
      color:white !important;
    }
    .dateComm {
      font-size: 0.8rem !important;
      font-weight:normal !important;
    }
</style>